<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Calm Pond</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004">Acknowledgment</a></li><li id="toc-li-5"><a href="#/text/ch005">Prologue</a></li><li id="toc-li-6"><a href="#/text/ch006">Introduction</a></li><li id="toc-li-7"><a href="#/text/ch007">Story 1. Danti Duck Loses Her Quack</a></li><li id="toc-li-8"><span href="#/text/ch008" title="Link target outside of Sample">Story 2. The Golden Balloon</span></li><li id="toc-li-9"><span href="#/text/ch009" title="Link target outside of Sample">Story 3. Sports Day</span></li><li id="toc-li-10"><span href="#/text/ch010" title="Link target outside of Sample">Story 4. Reach for the Stars</span></li><li id="toc-li-11"><span href="#/text/ch011" title="Link target outside of Sample">Story 5. Green Day</span></li><li id="toc-li-12"><span href="#/text/ch012" title="Link target outside of Sample">Story 6. Sheep Egg</span></li><li id="toc-li-13"><span href="#/text/ch013" title="Link target outside of Sample">Story 7. A Beautiful Friend</span></li><li id="toc-li-14"><span href="#/text/ch014" title="Link target outside of Sample">Story 8. Healing Tears</span></li><li id="toc-li-15"><span href="#/text/ch015" title="Link target outside of Sample">Story 9. Going My Way</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?c3876634